export enum ReviewsMood {
  Any = 'any',
  Positive = 'positive',
  Negative = 'negative',
}

export interface ITag {
  name: string;
}

export interface IReply {
  avatar: string;
  authorName: string;
  text: string;
  createdAt: string;
  type: string | null;
  alias: string | null;
}

export interface IReview {
  authorName: string;
  text: string;
  rating: number;
  tags?: ITag[] | null;
  createdAt: string;
  reply?: IReply | null;
}

export interface IReviewStats {
  allCount: number;
  positiveCount: number;
  negativeCount: number;
}

export interface IReviewOwner {
  id: number;
  alias: string;
  fullName: string;
  avatar: string;
  skillName: string;
}

export interface IReviewComment {
  id: number;
  authorName: string;
  text: string;
  rating: number;
  createdAt: string;
}

export interface IRecentReview {
  owner: IReviewOwner;
  comment: IReviewComment;
}
